import * as React from 'react';
import List from '@telia-front/list';
import Notification from '@telia-front/notification';
import { NotificationListItem } from '../index';
const NotificationList = (props) => {
    const { items, children, className } = props;
    const BEM = () => {
        const classArray = ['notification-list'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (React.createElement(List, { className: BEM(), type: "unstyled", fullWidth: true }, items
        ? items.map((item) => {
            return (React.createElement(NotificationListItem, { key: item.id },
                React.createElement(Notification, Object.assign({}, item))));
        })
        : children));
};
export { NotificationList as default };
